import type {} from "@lit/react";
import { Iconset as IconsetElement, } from "@vaadin/icon/vaadin-iconset.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { IconsetElement, };
export type IconsetEventMap = Readonly<{}>;
const events = {} as IconsetEventMap;
export type IconsetProps = WebComponentProps<IconsetElement, IconsetEventMap>;
export const Iconset = createComponent({
    elementClass: IconsetElement, events, react: React, tagName: "vaadin-iconset"
});
